import request from '@/utils/request'

// 购买记录
export function airdropBuyRecordList(data) {
    return request({
      url: '/admin/airdropBuyRecord/list',
      method: 'post',
      data
    })
  }
  export function airdropSaleRecordList(data) {
    return request({
      url: '/admin/airdropSaleRecord/list',
      method: 'post',
      data
    })
  }
  export function receiveConfigView(data) {
    return request({
      url: '/admin/airdropPackage/receiveConfigView',
      method: 'post',
      data
    })
  }
  export function updateReceiveConfig(data) {
    return request({
      url: '/admin/airdropPackage/updateReceiveConfig',
      method: 'post',
      data
    })
  }
// 领取记录 
export function airdropReceiveRecordList(data) {
  return request({
    url: '/admin/airdropReceiveRecord/list',
    method: 'post',
    data
  })
}
// 币种管理
export function list(data) {
  return request({
    url: '/admin/airdropPackage/list',
    method: 'post',
    data
  })
}
export function save(data) {
  return request({
    url: '/admin/airdropPackage/save',
    method: 'post',
    data
  })
}
export function update(data) {
  return request({
    url: '/admin/airdropPackage/update',
    method: 'post',
    data
  })
}
export function tradeTicketDelete(data) {
  return request({
    url: '/admin/airdropPackage/delete',
    method: 'post',
    data
  })
}